export const POC_DATA_REQUEST = 'POC_DATA_REQUEST';
export const POC_DATA_SUCCESS = 'POC_DATA_SUCCESS';
export const POC_DATA_FAIL = 'POC_DATA_FAIL';
